<template>
    <div>
        <div class="holder">
            <h2 id="page-header"><router-link to="/">My Arlington -</router-link><router-link to="/foodResources"> {{metadata.Title}}</router-link></h2>
            <div id="blurb" v-if="ready">
                <div v-html="markdownToHtml"></div>
              <br/>
            </div>
        </div>
        <div class="layer-page">
            <div class="widget one-third filter-pane">
                <div class="filter-header" id="mobile-menu" v-show="isMobile || mobileMenu === false" @click="mobileMenu = !mobileMenu">
                    Filters and Location
                    <svg v-show="!mobileMenu" style="float: right" class="icon"><use xlink:href="#icon-plus"></use></svg>
                    <svg v-show="mobileMenu" style="float: right" class="icon"><use xlink:href="#icon-minus"></use></svg>
                </div>
                <div id="filters-and-settings" v-show="!isMobile || mobileMenu">
                    <div class="filter-container">
                        <div class="filter-header" @click="filtersToggle" v-show="!isMobile" >
                            <span>Filters
                                <svg v-show="filtersExpanded" style="float: right" class="icon"><use xlink:href="#icon-minus"></use></svg>
                                <svg v-show="!filtersExpanded" style="float: right" class="icon"><use xlink:href="#icon-plus"></use></svg>
                                <div style="clear: both"></div>
                            </span>
                        </div>
                        <div class="filterList" v-show="filtersExpanded || mobileMenu"><br/>
                          <div v-for="(category,index) in metadata.FilterCategory"  :key="index">
                            <div class="filter-item filter-category">
                              {{category.Label}}
                            </div>
                             <div class="filter-item" v-for="(filterItem) in category.Filters" :key="filterItem.Label">
                              <input v-model="filterSelected" :value="category.Label + ':' + filterItem.Field + ':' + filterItem.Value" type="checkbox" />
                              <span class="tooltip">&nbsp;{{filterItem.Label}}
                                <span :class='"box " + filterItem.BoxIcon' v-show='filterItem.BoxIcon'></span>
                                <span class="tooltiptext" v-show='filterItem.Tooltip'>{{filterItem.Tooltip}}</span>
                                <span :class='filterItem.Icon' v-show='filterItem.class'></span>
                                <v-icon v-show='filterItem.Icon'>{{filterItem.Icon}}</v-icon>
                              </span>
                            </div>
                            <br>
                             <div class="filter-item" v-for="(filterItem) in category.PrecinctFilters" :key="filterItem.Label">
                              <input v-model="filterSelected" :value="category.Label + ':' + filterItem.Field + ':' + filterItem.Value" type="checkbox" />
                              <span class="tooltip">&nbsp;{{filterItem.Label}}
                                <span :class='"box " + filterItem.BoxIcon' v-show='filterItem.BoxIcon'></span>
                                <span class="tooltiptext" v-show='filterItem.Tooltip'>{{filterItem.Tooltip}}</span>
                                <span :class='filterItem.Icon' v-show='filterItem.class'></span>
                                <v-icon v-show='filterItem.Icon'>{{filterItem.Icon}}</v-icon>
                              </span>
                              <hr v-show="metadata.FilterCategory.length >index+1">
                              <br>
                            </div>
                          </div>
                        </div>
                    </div>
                    <div class="filter-container" v-if="metadata.CivicAssociationFilter">
                        <label for="civicAssociation">Civic Association</label>
                        <br />
                        <div>
                            <select id="civicAssociation" v-model="civicAssocationsSelected">
                                <option value="">Select a civic association</option>
                                <option v-for="ca in civicAssociations" :key="ca.OBJECTID" :value="ca">{{ca.LABEL}}</option>
                            </select>
                        </div>
                        <span v-show="civicAssociationFailure">Unable to load Civic Assocations.</span>
                    </div>
                    <div class="filter-container" v-if="metadata.VoterPrecinctFilter">
                        <label for="civicAssociation">Voter Precinct</label>
                        <br />
                        <div>
                            <select id="voterPrecinct" v-model="voterPrecinctSelected">
                                <option value="">Select a voter precinct</option>
                                <option v-for="ca in voterPrecincts" :key="ca.OBJECTID" :value="ca">{{ca.POLLING_PLACE}}</option>
                            </select>
                        </div>
                        <span v-show="voterPrecinctFailure">Unable to load Voter Precincts.</span>
                    </div>
                    <h3>Zoom to Location</h3>
                    <div class="filter-container zoom-container">
                        <label for="addressSearch">Address</label>
                        <br/>
                        <gmap-autocomplete ref="autocomplete" @place_changed="placeChanged"></gmap-autocomplete>
                    </div>
                    <div class="filter-container" v-if="metadata.RadiusFilter">
                        <label for="radius">Radius</label>
                        <br />
                        <div>
                            <select id="radius" v-model="radiusSelected" :disabled="!selectedCoordinates">
                                <option value="">Set distance</option>
                                <option value="0.5">0.5 Mile</option>
                                <option value="1">1 Mile</option>
                            </select>
                        </div>
                    </div>

                    <div class="filter-container">
                      <button class="link filter-header" @click="clearAll">Clear All</button>
                    </div>
                </div>
            </div>
            <div class="widget full-map-pane toggle-window two-thirds" v-if="ready">
                <div style="position: relative; top: 0">
                  <h3 class="toggle-bar">
                    <a :class="showMap === true ? 'toggle-link' : 'toggle-link active'" @click="showMap = true">Map</a>
                    <a :class="showMap === false ? 'toggle-link' : 'toggle-link active'" @click="showMap = false" id="list-link">List</a>
                  </h3>
                </div>
                <gmap-map
                    v-show="showMap"
                    :center="mapCenter"
                    :zoom="zoomLevel"
                    :options="mapStyles"
                    id="vue-map-container"
                    >
                    <div v-if="metadata.Type === 'Pins' || metadata.Type === 'Both'">
                      <gmap-marker  v-for="item in filteredItems"
                        :key="item.location_name"
                        :position="item"
                        :icon="item.icon"
                        :options="shapeOptions"
                        @click="(e) => shapeClick(item, e)">
                      </gmap-marker>

                      <!-- Common Info Window -->
                      <gmap-info-window
                        :opened="selectedInfoWindowPosition !== null"
                        :position="selectedInfoWindowPosition"
                        @closeclick="infoWindowCloseClick">
                          <h3 class="info-window-header"><b>{{selectedItem[metadata.PinPopupTitle]}}</b></h3>
                          <div class="info-window" v-for="(field,index) in metadata.PinPopupFields.split(',')" :key="index">
                            <b>{{field.indexOf('=') > 0 ? field.split('=')[1].trim() : field}}</b>: {{selectedItem[field.split('=')[0].trim()] || 'N/A'}}
                          </div>
                      </gmap-info-window>
                    </div>

                    <!--Radius Markers -->
                    <gmap-marker v-if="selectedCoordinates" :position="selectedCoordinates" :radius="24"></gmap-marker>
                    <GmapCircle v-if="selectedCoordinates && radiusSelected" :center="selectedCoordinates" :radius="radiusSelected*1609" :visible="true" :options="{fillColor:'blue',fillOpacity:0.1,strokeWeight:0.7,strokeColor:'blue'}"></GmapCircle>

                    <gmap-polygon v-if="civicAssocationsSelected" :path="civicAssocationsSelected.paths" :options="locationOptions"></gmap-polygon>
                    <gmap-polygon v-if="voterPrecinctSelected" :path="voterPrecinctSelected.paths" :options="locationOptions" @click="(e) => layerClick(voterPrecinctSelected, e)"></gmap-polygon>

                    <div v-if="metadata.Type === 'Layers' || metadata.Type === 'Both'" >
                      <gmap-polygon v-for="(layer,index) in filteredItems" :key="index" :path="layer.paths" :options="layer.options" @click="(e) => layerClick(layer, e)"></gmap-polygon>
                        <!-- Common Info Window -->
                      <gmap-info-window
                        :opened="selectedLayerWindowPosition !== null"
                        :position="selectedLayerWindowPosition"
                        @closeclick="layerWindowCloseClick">
                          <h3 class="info-window-header"><b>{{selectedItem[metadata.LayerPopupTitle]}}</b></h3>
                          <div class="info-window" v-if="metadata.LayerPopupFields" v-for="(field,index) in metadata.LayerPopupFields.split(',')" :key="index">
                            <b>{{field}}</b>: {{selectedItem[field.trim()] || 'N/A'}}
                          </div>
                      </gmap-info-window>
                    </div>
                </gmap-map>
                <div v-show="!showMap" class="list-pane">
                  <div v-for="(item,index) in filteredItems" :key="index" class="project">
                    <div class="row" >
                        <h3 class="h3-list"><b>{{item[metadata.ListTitle]}}</b></h3>
                        <p class="no-vertical-margin" v-if="metadata.ListFields" v-for="(field,index) in metadata.ListFields.split(',')" :key="index">
                          <b>{{field.indexOf('=') > 0 ? field.split('=')[1].trim() : field}}</b>: {{item[field.split('=')[0].trim()] || 'N/A'}}
                        </p>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import R from 'ramda';
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps'
import geolib from 'geolib';
import { mapGetters, mapActions } from 'vuex';
import marked from 'marked';
import moment from 'moment';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDIkJCuWTcYkqhKmKQBKgsFvLJYeZxUu4U',
    libraries: 'places'
  }
})

export default {
  name: 'map',
  data () {
    return {
      ready: false,
      isMobile: false,
      showMap: true,
      mobileMenu: null,
      filtersExpanded: true,
      mapStyles: {styles: [{featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }]}]},
      civicAssocationsSelected: '',
      voterPrecinctSelected: '',
      civicAssociationFailure: false,
      voterPrecinctFailure: false,
      // map properties
      center: {
        lat: 38.8809462,
        lng: -77.099029
      },
      radiusSelected: '',
      icon: {
        path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
        fillColor: '#0040FF',
        fillOpacity: 1,
        strokeWeight: 0.5,
        strokeColor: '#fff',
        scale: 1,
        anchor: { x: 14, y: 10 } // eslint-disable-line no-undef
      },
      shapeOptions: {
        strokeColor: '#0040FF',
        strokeOpacity: 0.9,
        strokeWeight: 4,
        fillColor: '#0040FF',
        fillOpacity: 0.35,
        zIndex: 2
      },
      locationOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        zIndex: 1
      },
      selectedCoordinates: null,
      selectedInfoWindowPosition: null,
      selectedLayerWindowPosition: null,
      selectedItem: {},
      searchText: '',
      filterSelected: [],
      status: '',
      metadata: [],
      mapdata: []
    }
  },
  computed: {
    ...mapGetters(['civicAssociations', 'voterPrecincts']),
    markdownToHtml () {
      return marked(this.metadata.Description);
    },
    zoomLevel: function () {
      if (!this.selectedCoordinates && (!this.civicAssocationsSelected && !this.voterPrecinctSelected)) {
        return 13;
      }
      return 15;
    },
    mapCenter: function () {
      if (this.selectedCoordinates) {
        return this.selectedCoordinates;
      }
      if (this.civicAssocationsSelected) {
        const civicCenter = geolib.getCenter(this.civicAssocationsSelected.paths);
        civicCenter.lat = Number(civicCenter.latitude);
        civicCenter.lng = Number(civicCenter.longitude);

        return civicCenter;
      }
      if (this.voterPrecinctSelected) {
        const voteCenter = geolib.getCenter(this.voterPrecinctSelected.paths);
        voteCenter.lat = Number(voteCenter.latitude);
        voteCenter.lng = Number(voteCenter.longitude);

        return voteCenter;
      }
      return this.center;
    },

    filteredItems: function () {
      let data;
      if (this.metadata.Type === 'Layers') {
        if (this.metadata.LayerType === 'VoterPrecinct') {
          data = this.voterPrecincts;
        }
      } else {
        data = this.mapdata;
      }
      return this.filterData(data);
    },

    strapiUrl () {
      let url = '';
    //  console.log(process.env.NODE_ENV)
      switch (process.env.NODE_ENV) {
        case 'production':
          url = 'https://strapi.arlingtonva.us';
          break;
        case 'testing':
          url = 'https://strapi.arlingtonva.us';
          break;
        default:
          url = 'https://strapi.arlingtonva.us';
          break
      }
      return url;
    }
  },

  mounted: async function () {
    this.ready = false;
    await this.getData()
    this.ready = true;
  },

  watch: {
    $route () {
      this.getData()
    }
  },
  methods: {
    ...mapActions(['loadCivicAssociations', 'loadVoterPrecincts']),

    async getData () {
      await this.getMetaData()
        .then(this.getMapData)
        .then(this.getAdditionalData)

      this.metadata.CivicAssociationFilter && await this.loadCivicAssociations();
      this.metadata.VoterPrecinctFilter && await this.loadVoterPrecincts();
      this.metadata.Type === 'Layers' && this.metadata.LayerType === 'VoterPrecinct' && await this.getVoterPrecincts();
    },

    async getMetaData () {
      this.status = 'loading'
      let response = await fetch(`${this.strapiUrl}/maps?slug=${this.$route.params.slug}`)
      if (!response.ok) {
        this.status = 'error'
        return
      }

      let json = await response.json()
      if (json.length === 0) {
        this.status = 'not-found'
        return
      }

      this.metadata = json[0]

      this.status = 'ok'
      this.metadata.OBJECTID = 'Object ID'
      console.log(this.metadata)
      return this.metadata;
    },

    async getMapData (metadata) {
      let appendTimestamp = metadata.data_source.indexOf('&') > 0 ? `&timestamp=${new Date().getTime()}` : `?&timestamp=${new Date().getTime()}`
      let data = await fetch(`${metadata.data_source}${appendTimestamp}`).then(response => response.json());
      const dateProperties = Object.getOwnPropertyNames(data[0]).filter(a => a.indexOf('Date') > 0)
      for (const r of data) {
        r.lat = parseFloat(r[metadata.LatIdentifier])
        r.lng = parseFloat(r[metadata.LonIdentifier])
        r.icon = {...this.icon};
        r.icon.fillColor = this.colorPin(r) || '#0040FF';
        for (const dp of dateProperties) {
          r[dp] = this.isIsoDate(r[dp]) ? r[dp].slice(0, 10) : r[dp]
          r[dp] = r[dp] ? moment(r[dp]).format('Y-MM-DD') : null
        }
      }

      this.mapdata = data;
      return this.mapdata;
    },

    async getAdditionalData (mapdata) {
      // load additional specific data for each map
      if (this.$route.params.slug === 'permit') {
        const realEstateUrl = 'https://datahub-v2.arlingtonva.us/api/RealEstate/Property?$select=realEstatePropertyCode,propertyZipCode,zoningDescListText&$filter=realEstatePropertyCode eq '
        mapdata = mapdata.filter(a => a.expiredDate == null)
        const removeStatus = ['Awaiting Plans and Documents', 'Application Complete', 'Additional Info Required']
        mapdata = mapdata.filter(a => !removeStatus.some(b => b === a.permitStatusCode))

        mapdata = mapdata.filter(a => {
          if (mapdata.filter(b => b.permitNbr === a.permitNbr).length > 1 && (a.permitStatusCode === 'Approved' || a.permitStatusCode === 'Denied' || a.permitStatusCode === 'Withdrawn' || a.permitStatusCode === 'Void')) {
            return a
          } else if (mapdata.filter(b => b.permitNbr === a.permitNbr).length === 1) {
            return a
          }
        })
        this.mapdata = mapdata
        let tempData = mapdata
        var size = 10;
        var chunkedArray = []
        for (let i = 0; i < tempData.length; i += size) {
          chunkedArray.push(tempData.slice(i, i + size));
        }
        let dataArray = []
        for (const chunk of chunkedArray) {
          let queryString = chunk.map(u => `'${u.realEstatePropertyCode}'`).join(' or realEstatePropertyCode eq ')
          let queryUrl = encodeURI(realEstateUrl + queryString)
          let data = await fetch(queryUrl).then(response => response.json());
          dataArray.push(data)
        }
        dataArray = dataArray.flat()
        this.mapdata = this.mapdata.map(obj => {
          let matched = dataArray.find(a => a.realEstatePropertyCode === obj.realEstatePropertyCode)
          return ({ ...obj, propertyZipCode: matched.propertyZipCode, zoningDescListText: matched.zoningDescListText })
        })

        for (const r of this.mapdata) {
          r.yearSort = moment(r.issuedDate).year()
        }
        this.addFilterCategory('Zoning District', 'zoningDescListText', this.getUniqueItems('zoningDescListText', this.mapdata))
        this.addFilterCategory('Issued Year', 'yearSort', this.getUniqueItems('yearSort', this.mapdata).filter(a => !isNaN(a)))
        return;
      }
    },

    getUniqueItems (prop, list) {
      let uniqueItems = R.uniq(R.map(R.prop(prop), list))
      return uniqueItems
    },

    addFilterCategory (label, field, list) {
      let filterCategoryFilters = list.map(a => {
        return {
          'BoxIcon': null,
          'CssClass': null,
          'Field': field,
          'Icon': null,
          'Label': a,
          'Tooltip': null,
          'Value': a
        }
      })
      let filterCategory = {
        Label: label,
        Filters: filterCategoryFilters
      }
      this.metadata.FilterCategory.push(filterCategory)
    },

    isIsoDate (str) {
      if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false;
      const d = new Date(str);
      return d instanceof Date && !isNaN(d.getTime()) && d.toISOString() === str;
    },

    async getVoterPrecincts () {
      /* Map colors */
      var items = [];

      var url = 'https://arlgis.arlingtonva.us/arcgis/rest/services/Open_Data/od_Voter_Precinct_Polygons/FeatureServer/0/query?outFields=*&where=1%3D1&f=geojson';

      let response = await fetch(url).then(response => response.json());

      var columnHeaders = Object.keys(response.features[0].properties);

      items.length = 0;

      let res = this.mapdata.map(x => Object.assign(x, response.features.find(y => { return y.properties.OBJECTID === parseInt(x[this.metadata.OBJECTID]) })));
      res.forEach(function (voterPrecinct) {
        var item = {...voterPrecinct};

        for (var i = 0; i < columnHeaders.length; i++) {
          var propertyName = columnHeaders[i];
          var propertyValue = voterPrecinct[propertyName];
          item[propertyName] = propertyValue;
        }
        try {
          item.coordinates = voterPrecinct.geometry.coordinates[0];
          // Setup google map polygon
          item.paths = [];
          item.coordinates.forEach(coord => {
            var latLng = {
              lng: Number(coord[0]),
              lat: Number(coord[1])
            }
            item.paths.push(latLng);
          })

          item.popupInfo = item.PREC_NAME;

          var options = {};
          options.strokeColor = voterPrecinct.Color;
          options.strokeOpacity = 0.8;
          options.strokeWeight = 2;
          options.fillColor = voterPrecinct.Color;
          options.fillOpacity = 0.60;

          item.options = options;
          items.push(item);
        } catch (e) {
          console.log(e)
        }
      });
      this.voterPrecincts = items.sort((a, b) => a.PREC_NAME.localeCompare(b.PREC_NAME));
    },

    colorPin (item) {
      let color;
      for (const category of this.metadata.FilterCategory) {
        for (const filter of category.Filters) {
          if (item[filter.Field] === filter.Value) {
            color = filter.BoxIcon;
          }
        }
      }
    //  console.log(color);
      return color;
    },

    filterData (items) {
      if (this.filterSelected.length > 0) {
        this.metadata.FilterCategory.forEach(category => {
          if (this.filterSelected.some(cat => cat.split(':')[0] === category.Label)) {
            items = items.filter(item => this.filterSelected.some(selected => {
              let split = selected.split(':');
              return (
                category.Label === split[0] && item[split[1]].toString().toLowerCase() === split[2].toString().toLowerCase()
              );
            }))
          }
        })
      }
      return items;
    },

    filterRadius (items) {
      if (this.selectedCoordinates && this.radiusSelected) {
        items.map(m => {
          m.distance = geolib.getDistance({ latitude: this.selectedCoordinates.lat, longitude: this.selectedCoordinates.lng }, { latitude: m.lat, longitude: m.lng })
        })
        items = items.filter(f => this.radiusSelected * 1609 >= f.distance)
      }
      return items;
    },

    filtersToggle: function () {
      this.filtersExpanded = !this.filtersExpanded
    },
    clearAll () {
      this.filterSelected = [];
      this.selectedCoordinates = null;
      this.civicAssocationsSelected = '';
      this.$refs.autocomplete.$refs.input.value = '';
      this.radiusSelected = '';
      this.voterPrecinctSelected = '';
    },
    placeChanged: function (place) {
      this.selectedCoordinates = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
    },
    setLocation: function (lat, lng) {
      this.selectedCoordinates = { lat: lat, lng: lng };
    },
    getCurrentLocation: function () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(pos => {
          this.selectedCoordinates = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        }, err => {
          alert('Unable to determine current location at this time.');
          return err;
        });
      }
    },
    shapeClick: function (item, clickEvent) {
      this.selectedItem = item;
      this.selectedInfoWindowPosition = clickEvent.latLng;
    },
    infoWindowCloseClick: function () {
      this.selectedItem = {};
      this.selectedInfoWindowPosition = null;
    },
    infoWindowCheck () {
      if (this.selectedItem && this.selectedItem.id) {
        const ifCheck = R.find(p => p.id === this.selectedItem.id)(this.filteredItems);
        if (ifCheck === null || ifCheck === undefined) {
          this.selectedItem = {};
          this.selectedInfoWindowPosition = null;
        }
      }
    },

    layerClick: function (item, clickEvent) {
      this.selectedItem = item;
      this.selectedLayerWindowPosition = clickEvent.latLng;
    },
    layerWindowCloseClick: function () {
      this.selectedItem = {};
      this.selectedLayerWindowPosition = null;
    },
    layerWindowCheck () {
      if (this.selectedItem && this.selectedItem.id) {
        const ifCheck = R.find(p => p.id === this.selectedItem.id)(this.filteredItems);
        if (ifCheck === null || ifCheck === undefined) {
          this.selectedItem = {};
          this.selectedLayerWindowPosition = null;
        }
      }
    },

    parentStatusClick (parentStatus) {
      var statusValues = R.map(R.prop('value'), parentStatus.subStatuses);
      statusValues.forEach(s => {
        const i = this.subStatusesSelected.indexOf(s.value);
        if (i >= 0) {
          this.subStatusesSelected.splice(i, 1);
        }
      });
    }
  }
}

</script>

<style lang="scss" scoped>
    .filter-category {
      font-weight: bold;
      font-size: 1.45em;
    }

    .toggle-link {
      cursor: pointer;
      padding: 0 12px;
      color: #e87c1a;
    }

    .active {
      color: #015cb9;
    }

    .toggle-window {
      border: 2px solid #f1f1f1;
      padding: 8px;
      margin-bottom: 4px;
    }

    #list-link {
      border-left: 2px solid #f1f1f1;
    }

    .toggle-bar {
      padding-bottom: 8px;
      border-bottom: 2px solid #f1f1f1;
    }

    p.no-vertical-margin {
      margin-bottom: 0;
      margin-top: 0;
    }

    .project {
      margin-bottom: 1rem;
    }

.list-pane {
  overflow-y: scroll;
}

.operations-list {
  li {
    font-size: 1em;
    padding: 0px;
  }
}

.h3-list {
  margin: 0px;
}

.column {
  float: left;
  width: 50%;
  min-width: 145px;
  min-height: 55px;
}

.info-window-header {
  margin: 0px;
}

.info-window-body {
  clear: both;
}

.header-column-left {
  float: left;
  width: 75%;
  min-height: 30px;
}

.header-column-right {
  float: left;
  width: 25%;
  min-width: 15px;
  min-height: 30px;
  margin-bottom: 3px;
  height: auto;
  span {
    font-size: 20px;
  }
}

.list-header-column-left {
  float: left;
  width: 75%;
  min-height: 25px;
}

.list-header-column-right {
  float: left;
  width: 25%;
  min-width: 15px;
  min-height: 25px;
  margin-bottom: 1px;
  height: auto;
  span {
    font-size: 20px;
    margin-top: 6px;
  }
}

.row:after {
  display: table;
  clear: both;
}

.transit-row {
  font-size: 20px;
}

.filter-item-nested {
  margin-left: 10px;
}

.box {
  float: right;
  height: 16px;
  width: 16px;
  margin-left: 5px;
  margin-right: 5px;
  margin-top: 3px;
  border: 1px solid black;
  clear: both;
}

.red {
  background-color: #ff0000;
}

.purple {
  background-color: #990099;
}

.green {
  background-color: #009933;
}

.blue {
  background-color: #0040FF;
}

.orange {
  background-color: #ff6633;
}
@media (max-width: 650px) {
  .list-pane {
    max-height: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// map.vue?8db5d108